// extracted by mini-css-extract-plugin
module.exports = {"controlsWrapper":"carousel_controlsWrapper__QgdCf","customPagination":"carousel_customPagination__HxY3A"};